var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowLightInsertedSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.56 294.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#f7f1ae;}.cls-3{fill:#8e9167;}.cls-4{fill:none;stroke:#ed2024;stroke-miterlimit:10;stroke-width:0.99px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,274.88a8,8,0,0,0,8,8h95.55V0H32.83C25.66,0,23,3.08,22.89,10.5s-.05,1.64,0,12.16c0,9.61-6.6,10.46-6.6,10.46S10,34.16,10,41.91,10,274.88,10,274.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,285.18a8,8,0,0,0,8,8h95.55V10.31H22.84c-7.18,0-9.86,3.08-9.95,10.5s0,1.64,0,12.15c0,9.62-6.6,10.47-6.6,10.47S0,44.46,0,52.21,0,285.18,0,285.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.1,41A24.54,24.54,0,0,1,79,65.67l-.2,174.66a25.49,25.49,0,0,1-24.9,25.37A24.54,24.54,0,0,1,29,241.06L29.2,66.4A25.49,25.49,0,0,1,54.1,41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.73,
    y: 294.63,
    width: 0.37,
    transform: "translate(-281.72 307.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.84,10.3h-4V42.35a28.62,28.62,0,0,1,4-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.84,293.18h4V267.29a27.53,27.53,0,0,1-4-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.78,293.18h4V269.51a28,28,0,0,1-4-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.78,10.3h-4v28a28,28,0,0,1,4-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.6,269.7v23.48h4V269.62l-1.31.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.58,37h1V10.3h-4V37.07h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.41,293.18h4V268a27,27,0,0,1-4,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.41,10.3h-4V37.4a26.57,26.57,0,0,1,4,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.65,10.3h-4V39.7a26.37,26.37,0,0,1,4,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.65,293.18h4V264a27.62,27.62,0,0,1-4,2.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLightInsertedSide);
export default __webpack_public_path__ + "static/media/yellow-light-inserted-side.6b1fee9f5c23209de42fe121127d9158.svg";
export { ForwardRef as ReactComponent };